import React from 'react';
import { Typography, Card, Layout, Button, Row, Col, Divider } from 'antd';
import { 
  ArrowLeftOutlined, 
  ClockCircleOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const Support = () => {
  const navigate = useNavigate();

  const faqData = [
    {
      category: 'Getting Started',
      questions: [
        {
          q: 'How do I register for a business account?',
          a: 'Click "Register" and provide your business details including company name, tax ID, and authorized representative information. Account verification typically takes 1-2 business days.'
        },
        {
          q: 'What documents are required for verification?',
          a: 'You need a valid business license, tax identification document, and proof of authorized signatory. Additional documents may be required based on your business type.'
        },
        {
          q: 'How long does account approval take?',
          a: 'Standard accounts are approved within 1-2 business days. Premium accounts with credit terms may take 3-5 business days for complete verification.'
        }
      ]
    },
    {
      category: 'Orders & Payment',
      questions: [
        {
          q: 'What payment methods do you accept?',
          a: 'We accept major credit cards, ACH bank transfers, wire transfers, and for approved accounts, net payment terms (15, 30, or 60 days).'
        },
        {
          q: 'How are voucher codes delivered?',
          a: 'Voucher codes are delivered instantly to your account dashboard upon payment confirmation. You also receive email confirmation with download links.'
        },

      ]
    },
    {
      category: 'Voucher Management',
      questions: [
        {
          q: 'How do I track voucher code usage?',
          a: 'Voucher code information and status can be accessed through your account dashboard.'
        },
        {
          q: 'What if a voucher code doesn\'t work?',
          a: 'Contact support immediately with the code details. We provide replacements for verified defective codes within 24 hours.'
        },
        {
          q: 'Do voucher codes expire?',
          a: 'Yes, expiration dates vary by brand and are clearly displayed in your account. Most codes are valid for 12-24 months from purchase.'
        }
      ]
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(145deg, #FAFBFE 0%, #F4F6FB 30%, #EEF2FA 100%)' }}>
      <Content style={{ padding: '24px 48px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ marginBottom: 24 }}>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/')}
            style={{ marginBottom: 16 }}
          >
            Back to Home
          </Button>
        </div>

        <Card style={{ boxShadow: '0 4px 16px rgba(139, 122, 174, 0.12)', borderRadius: 16, marginBottom: 24 }}>
          <Title level={1} style={{ color: '#2D3748', marginBottom: 32 }}>Support Center</Title>
          
          <Paragraph style={{ fontSize: '18px', color: '#4A5568', marginBottom: 32 }}>
            Find answers to common questions and get help with using our voucher platform effectively.
          </Paragraph>

        </Card>

        <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            <Card style={{ boxShadow: '0 4px 16px rgba(139, 122, 174, 0.12)', borderRadius: 16 }}>
              <Title level={2} style={{ color: '#2D3748', marginBottom: 24 }}>
                <QuestionCircleOutlined style={{ marginRight: 8 }} />
                Frequently Asked Questions
              </Title>
              
              {faqData.map((category, categoryIndex) => (
                <div key={categoryIndex} style={{ marginBottom: 32 }}>
                  <Title level={3} style={{ color: '#2D3748', marginBottom: 16 }}>
                    {category.category}
                  </Title>
                  
                  {category.questions.map((faq, faqIndex) => (
                    <div key={faqIndex} style={{ marginBottom: 20 }}>
                      <Title level={4} style={{ color: '#4A5568', marginBottom: 8, fontSize: '16px' }}>
                        Q: {faq.q}
                      </Title>
                      <Paragraph style={{ color: '#4A5568', marginLeft: 16, marginBottom: 16 }}>
                        A: {faq.a}
                      </Paragraph>
                      {faqIndex < category.questions.length - 1 && <Divider />}
                    </div>
                  ))}
                </div>
              ))}
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card style={{ boxShadow: '0 4px 16px rgba(139, 122, 174, 0.12)', borderRadius: 16, marginBottom: 24 }}>
              <Title level={3} style={{ color: '#2D3748', marginBottom: 16 }}>
                <ClockCircleOutlined style={{ marginRight: 8 }} />
                Support Availability
              </Title>
              
              <div style={{ marginBottom: 16 }}>
                <Text strong style={{ color: '#2D3748' }}>Platform Support</Text>
                <br />
                <Text style={{ color: '#4A5568' }}>Available during business hours</Text>
              </div>

              <div>
                <Text strong style={{ color: '#2D3748' }}>Email Support</Text>
                <br />
                <Text style={{ color: '#4A5568' }}>Response within business days</Text>
              </div>
            </Card>


          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Support; 